import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import VegetableSection from "./components/VegetableSection";
import VegetableCatalog from "./components/VegetableCatalog";
import VegetableShowcase from "./components/VegetableShowcase";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ContactPage from "./components/Contact";
import AboutPage from "./components/AboutPage";
import BrandPage from "./components/BrandPage";
import Quality from "./components/Quality";


function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <Routes>
        {/* Home */}
        <Route
          path="/"
          element={
            <>
              <Banner />
              <VegetableSection />
              <VegetableShowcase />
              <VegetableCatalog />
              <Contact />
            </>
          }
        />
     <Route path="contact-page"element={<ContactPage/>}/>
     <Route path="about-page"element={<AboutPage/>}/>
     <Route path="brand-page"element={<BrandPage/>}/>
     <Route path="quality"element={<Quality/>}/>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
